import { PageHeader } from '@/components';
import { WhatsNewWidget } from '@/features/welcome/WhatsNewWidget';

export default function Welcome() {
  return (
    <section>
      <PageHeader title="Home" />
      {/* Widget grid — more widgets land here later. */}
      <div class="mx-auto grid max-w-6xl gap-6 p-6">
        <WhatsNewWidget />
      </div>
    </section>
  );
}
